var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": "20px" } },
    [
      _c("ve-pie", {
        attrs: {
          data: _vm.chartData,
          settings: _vm.chartSettings,
          extend: _vm.chartExtend
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }